import { Controller } from "@hotwired/stimulus"

// The pen name, offered from the composer. Once a member without one has a
// real draft under way - a dozen words or more, typed rather than pasted in
// one go - a small card rises under their monogram and says what a pen name
// is here; a second step in the same card takes the name and handle. "Not
// now" puts the offer away for a season (the server remembers) and this
// browser does not raise it again this visit either.
export default class extends Controller {
  static targets = ["card", "step", "anchor", "name"]
  static values = { dismissUrl: String }

  static WORDS = 12
  static ONCE = "substance:pen-name:offered"

  connect() {
    this.place = () => this.position()
    window.addEventListener("resize", this.place)
  }

  disconnect() {
    window.removeEventListener("resize", this.place)
  }

  typed(event) {
    if (this.shown || sessionStorage.getItem(this.constructor.ONCE)) return

    const words = event.target.value.trim().split(/\s+/).filter(Boolean).length
    if (words < this.constructor.WORDS) return

    this.show()
  }

  show() {
    this.shown = true
    sessionStorage.setItem(this.constructor.ONCE, "1")
    this.position()
    this.cardTarget.hidden = false
    requestAnimationFrame(() => this.cardTarget.classList.add("pen-offer-in"))
  }

  next() {
    this.stepTargets.forEach((step) => (step.hidden = step.dataset.step !== "2"))
    if (this.hasNameTarget) this.nameTarget.focus()
  }

  dismiss() {
    this.cardTarget.classList.remove("pen-offer-in")
    setTimeout(() => (this.cardTarget.hidden = true), 180)
    if (this.dismissUrlValue) {
      fetch(this.dismissUrlValue, { method: "POST", headers: { "X-CSRF-Token": this.token, Accept: "application/json" }, credentials: "same-origin" }).catch(() => {})
    }
  }

  // Just under the composer, so it covers none of the words being written,
  // with its point up in the monogram's column; on a narrow screen it takes
  // the composer's width.
  position() {
    if (!this.hasAnchorTarget || !this.hasCardTarget) return

    const anchor = this.anchorTarget.getBoundingClientRect()
    const plate = this.element.getBoundingClientRect()

    const wide = plate.width > 480
    const left = wide ? Math.max(anchor.left - plate.left - 8, 0) : 0
    this.cardTarget.style.left = `${left}px`
    this.cardTarget.style.right = wide ? "auto" : "0"
    this.cardTarget.style.width = wide ? "23rem" : "auto"
    this.cardTarget.style.setProperty("--point-left", `${anchor.left - plate.left + anchor.width / 2 - left}px`)
  }

  get token() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
